import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  // Attributes
  isFetchingAttributeData: false,
  attributeData: [],
  selectedAttributes: [],

  // Tooltip Attributes
  tooltipAttributes: [],

  // Saved Searches
  isFetchingSavedSearchData: false,
  savedSearchData: [],
  selectedSavedSearch: null,

  // Agreements
  isFetchingAgreementData: false,
  agreementData: null,
  selectedAgreement: null,

  // Associations
  isFetchingAssociationData: false,
  associationData: [],
  selectedAssociation: null,

  // Association Instances
  isFetchingAssociationInstances: false,
  associationInstancesData: [],

  // Attach Docs to Email
  docsToAttach: [],
};

const attachFromIciSlice = createSlice({
  name: "attach-from-ici",
  initialState: INITIAL_STATE,
  reducers: {
    // Attributes
    startFetchingAttributesAttachFromIci(state) {
      state.isFetchingAttributeData = true;
      state.attributeData = [];
      state.selectedAttributes = [];
    },
    storeAttributeDataAttachFromIci(state, action) {
      state.attributeData = action.payload;
      state.selectedAttributes = [];
      state.isFetchingAttributeData = false;
    },
    setSelectedAttributesAttachFromIci(state, action) {
      state.selectedAttributes = action.payload;
    },

    // Tooltip Attributes
    storeTooltipAttributesAttachFromIci(state, action) {
      state.tooltipAttributes = action.payload;
    },

    // Saved Searches
    startFetchingSavedSearchDataAttachFromIci(state) {
      state.isFetchingSavedSearchData = true;
      state.savedSearchData = [];
      state.agreementData = null;
      state.selectedAgreement = null;
      state.associationData = [];
      state.selectedAssociation = null;
      state.associationInstancesData = [];
      state.selectedAttributes = [];
    },
    storeSavedSearchDataAttachFromIci(state, action) {
      const data = action.payload;
      state.savedSearchData = data;
      state.selectedSavedSearch = data && data.length > 0 ? data[0] : null;
      state.isFetchingSavedSearchData = false;
    },
    onSavedSearchChangeAttachFromIci(state, action) {
      state.selectedSavedSearch = action.payload;
      state.agreementData = null;
      state.selectedAgreement = null;
      state.associationData = [];
      state.selectedAssociation = null;
      state.associationInstancesData = [];
      state.selectedAttributes = [];
      state.docsToAttach = [];
    },

    // Agreements
    startFetchingAgreementsAttachFromIci(state) {
      state.isFetchingAgreementData = true;
      state.agreementData = null;
      state.selectedAgreement = null;
      state.associationData = [];
      state.selectedAssociation = null;
      state.associationInstancesData = [];
    },
    storeAgreementDataAttachFromIci(state, action) {
      state.agreementData = action.payload;
      state.isFetchingAgreementData = false;
    },
    setSelectedAgreementAttachFromIci(state, action) {
      state.selectedAgreement = action.payload;
      state.associationData = [];
      state.selectedAssociation = null;
      state.associationInstancesData = [];
      state.docsToAttach = [];
    },

    // Associations
    startFetchingAssociationsAttachFromIci(state) {
      state.isFetchingAssociationData = true;
      state.associationData = [];
      state.selectedAssociation = null;
      state.associationInstancesData = [];
    },
    storeAssociationDataAttachFromIci(state, action) {
      state.associationData = action.payload;
      state.isFetchingAssociationData = false;
    },
    setSelectedAssociationAttachFromIci(state, action) {
      state.selectedAssociation = action.payload;
      state.associationInstancesData = [];
    },

    // Association Instances
    startFetchingAssociationInstancesAttachFromIci(state) {
      state.isFetchingAssociationInstances = true;
    },
    storeAssociationInstancesDataAttachFromIci(state, action) {
      state.associationInstancesData = action.payload;
      state.isFetchingAssociationInstances = false;
    },

    // Attach Docs to Email
    setDocsForAttachToEmailAttachFromIci(state, action) {
      state.docsToAttach = action.payload;
    },
  },
});

const { actions, reducer } = attachFromIciSlice;

export const {
  startFetchingAttributesAttachFromIci,
  storeAttributeDataAttachFromIci,
  setSelectedAttributesAttachFromIci,
  startFetchingSavedSearchDataAttachFromIci,
  storeSavedSearchDataAttachFromIci,
  onSavedSearchChangeAttachFromIci,
  startFetchingAgreementsAttachFromIci,
  storeAgreementDataAttachFromIci,
  setSelectedAgreementAttachFromIci,
  startFetchingAssociationsAttachFromIci,
  storeAssociationDataAttachFromIci,
  setSelectedAssociationAttachFromIci,
  startFetchingAssociationInstancesAttachFromIci,
  storeAssociationInstancesDataAttachFromIci,
  storeTooltipAttributesAttachFromIci,
  setDocsForAttachToEmailAttachFromIci,
} = actions;

export default reducer;
